import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const AccountLayout = lazy(() => import('newApp/layouts/account-layout/AccountLayout'));
const MyAccountPage = lazy(() => import('./pages/my-account/MyAccountPage'));
const EditProfilePage = lazy(() => import('./pages/edit-profile/EditProfilePage'));
const EditShopPage = lazy(() => import('./pages/edit-shop/EditShopPage'));
const DocumentsPage = lazy(() => import('./pages/documents/DocumentsPage'));
const MyRatingPage = lazy(() => import('./pages/my-rating/MyRatingPage'));
const AccountStatsPage = lazy(() => import('./pages/account-stats/AccountStatsPage'));
const FollowersPage = lazy(() => import('./pages/followers/FollowersPage'));
const FollowingPage = lazy(() => import('./pages/following/FollowingPage'));
const SettingsPage = lazy(() => import('./pages/settings/SettingsPage'));
const MyWalletPage = lazy(() => import('./pages/my-wallet/MyWalletPage'));
const BundleUsagePage = lazy(() => import('./pages/bundle-usage/BundleUsagePage'));
const OrderReceiptsPage = lazy(() => import('./pages/order-receipts/OrderReceiptsPage'));
const ReceiptPage = lazy(() => import('./pages/receipt/ReceiptPage'));
const OrderInvoicePage = lazy(() => import('./pages/order-invoice/OrderInvoicePage'));
const CvViewPage = lazy(() => import('./pages/cv/CvViewPage'));
const CvEditPage = lazy(() => import('./pages/cv/CvEditPage'));
const CvStatsPage = lazy(() => import('./pages/cv/CvStatsPage'));
const MainLayout = lazy(() => import('newApp/layouts/main-layout/MainLayout'));

const accountRoutes = [
  {
    path: '/account',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Navigate replace to="/account/my-account" />,
      },
      {
        element: <AccountLayout />,
        children: [
          {
            path: '/account/my-account',
            element: <MyAccountPage />,
            handle: {
              title: 'routes.account.myAccount',
              breadcrumb: 'routes.account.myAccount',
            },
          },
          {
            path: '/account/edit-profile',
            element: <EditProfilePage />,
            handle: {
              title: 'routes.account.myAccount',
              breadcrumb: 'routes.account.editProfile',
            },
          },
          {
            path: '/account/edit-shop',
            element: <EditShopPage />,
            handle: {
              title: 'routes.account.myAccount',
              breadcrumb: 'routes.account.editShop',
            },
          },
          {
            path: '/account/documents',
            element: <DocumentsPage />,
            handle: {
              title: 'routes.account.myAccount',
              breadcrumb: 'routes.account.documents',
            },
          },
          {
            path: '/account/my-rating',
            element: <MyRatingPage />,
            handle: {
              title: 'routes.account.myRating',
              breadcrumb: 'routes.account.myRating',
            },
          },
        ],
      },
      {
        path: '/account/my-account/account-stats',
        element: <AccountStatsPage />,
        handle: {
          title: 'routes.account.accountStats',
          breadcrumb: 'routes.account.accountStats',
        },
      },
      {
        path: '/account/followers',
        element: <FollowersPage />,
        handle: {
          title: 'routes.account.followers',
          breadcrumb: 'routes.account.followers',
        },
      },
      {
        path: '/account/following',
        element: <FollowingPage />,
        handle: {
          title: 'routes.account.followings',
          breadcrumb: 'routes.account.followings',
        },
      },
      {
        path: '/account/my-wallet',
        handle: {
          breadcrumb: 'routes.account.myWallet',
        },
        children: [
          {
            index: true,
            element: <MyWalletPage />,
            handle: {
              title: 'routes.account.myWallet',
            },
          },
          {
            path: 'bundle-usage/:id',
            element: <BundleUsagePage />,
            handle: {
              title: 'routes.account.bundleUsage',
              breadcrumb: 'routes.account.bundleUsage',
            },
          },
        ],
      },
      {
        path: '/account/order-receipts',
        element: <OrderReceiptsPage />,
        handle: {
          title: 'routes.account.receipts',
          breadcrumb: 'routes.account.receipts',
        },
      },
      {
        path: '/account/receipt',
        element: <ReceiptPage />,
        handle: {
          title: 'routes.account.receipts',
          breadcrumb: 'routes.account.receipts',
        },
      },
      {
        path: '/account/order-details',
        element: <OrderInvoicePage />,
        handle: {
          title: 'routes.account.invoice',
          breadcrumb: 'routes.account.invoice',
        },
      },
      {
        path: '/account/settings',
        element: <SettingsPage />,
        handle: {
          title: 'routes.account.settings',
          breadcrumb: 'routes.account.settings',
        },
      },
      {
        path: '/account/cv/view',
        element: <CvViewPage />,
        handle: {
          title: 'routes.account.myCv',
          breadcrumb: 'routes.account.myCv',
        },
      },
      {
        path: '/account/cv/edit',
        element: <CvEditPage />,
        handle: {
          title: 'routes.account.myCv',
          breadcrumb: 'routes.account.myCv',
        },
      },
      {
        path: '/account/cv/cv-stats',
        element: <CvStatsPage />,
        handle: {
          title: 'routes.account.cvStats',
          breadcrumb: 'routes.account.cvStats',
        },
      },
    ],
    handle: {
      breadcrumb: 'routes.account',
      breadcrumbLink: false,
    },
  },
];

export default accountRoutes;
